/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ExcerptTitle } from '../../excerpt/title/ExcerptTitle';
import { Hyperlink } from '../../Hyperlink';

import { useRestrictedModal } from '../../modal/useRestrictedModal';

import styles from './preparatory_work_result_item.module.scss';

type Props = {
  abstract: string;
  accessPremium: boolean;
  title: string;
  url: string;
  onClick: () => void;
  source: string;
};

export const PreparatoryWorkResultItem: FC<Props> = ({
  abstract,
  accessPremium,
  title,
  url,
  onClick,
  source,
}) => {
  const { openRestrictedModal } = useRestrictedModal();

  const onItemClick = () => {
    if (accessPremium) {
      onClick();
    } else {
      openRestrictedModal({ source });
    }
  };

  return (
    <div data-test-id="search-result-pw-item">
      <ExcerptTitle
        {...(accessPremium ? { href: url, target: '_blank' } : {})}
        onClick={onItemClick}
        id="search-result-pw-item-title"
      >
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </ExcerptTitle>
      <div className={styles.abstractContainer}>
        <p
          className={styles.abstract}
          dangerouslySetInnerHTML={{ __html: abstract }}
        />
        <Hyperlink
          className={styles.seeMore}
          onClick={onItemClick}
          {...(accessPremium ? { href: url, target: '_blank' } : {})}
        >
          <FormattedMessage id="components/search/preparatory-work/PreparatoryWorkResultItem.tsx/1" />
        </Hyperlink>
      </div>
    </div>
  );
};
